import { useEffect, useRef, useState } from "react";
import "../styles/SahyadriBankBanner.css";
import bankLogo from "../assets/photos/Banner-logo.png";

const SLIDES = [
  { id: 0, step: "Enter your account number & tap Continue" },
  { id: 1, step: "App opens — view your available balance instantly" },
  { id: 2, step: "Browse all your last transactions easily" },
  { id: 3, step: null }, // disclaimer — no step bullet
];

const DURATIONS = [4200, 3000, 3000, 4000];
const ACC_NUM   = "1234567890";
const MPIN      = "••••";

const TXN_S2 = [
  { name: "NEFT — Yash Dhanawde", date: "15 Mar 2026", amt: "+₹5,000",  type: "cr" },
  { name: "Bill Pay — MSEB",  date: "14 Mar 2026", amt: "-₹1,240",  type: "dr" },
  { name: "UPI — Suresh K.",  date: "13 Mar 2026", amt: "-₹800",    type: "dr" },
];

const TXN_S3 = [
  { name: "NEFT — Yash Dhanawde", date: "15 Mar 2026", amt: "+₹5,000",  type: "cr" },
  { name: "Bill Pay — MSEB",  date: "14 Mar 2026", amt: "-₹1,240",  type: "dr" },
  { name: "UPI — Suresh K.",  date: "13 Mar 2026", amt: "-₹800",    type: "dr" },
  { name: "Salary Credit",    date: "10 Mar 2026", amt: "+₹45,000", type: "cr" },
  { name: "ATM Withdrawal",   date: "09 Mar 2026", amt: "-₹3,000",  type: "dr" },
];

export default function SahyadriBankBanner() {
  const [current,     setCurrent]     = useState(0);
  const [accTyped,    setAccTyped]    = useState("");
  const [mpinTyped,   setMpinTyped]   = useState("");
  const [cursorField, setCursorField] = useState("acc");

  const cycleTimer = useRef(null);
  const typeTimer  = useRef(null);

  function typeText(text, setter, charDelay, onDone) {
    clearInterval(typeTimer.current);
    let i = 0;
    setter("");
    typeTimer.current = setInterval(() => {
      i++;
      setter(text.slice(0, i));
      if (i >= text.length) {
        clearInterval(typeTimer.current);
        if (onDone) onDone();
      }
    }, charDelay);
  }

  function runScreen1() {
    setCurrent(0);
    setAccTyped("");
    setMpinTyped("");
    setCursorField("acc");
    setTimeout(() => {
      typeText(ACC_NUM, setAccTyped, 110, () => {
        setCursorField("mpin");
        setTimeout(() => {
          typeText(MPIN, setMpinTyped, 180, () => setCursorField(null));
        }, 300);
      });
    }, 400);
  }

  function scheduleNext(idx) {
    clearTimeout(cycleTimer.current);
    cycleTimer.current = setTimeout(() => {
      const next = (idx + 1) % SLIDES.length;
      if (next === 0) { runScreen1(); scheduleNext(0); }
      else            { setCurrent(next); scheduleNext(next); }
    }, DURATIONS[idx]);
  }

  useEffect(() => {
    runScreen1();
    scheduleNext(0);
    return () => {
      clearTimeout(cycleTimer.current);
      clearInterval(typeTimer.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function goTo(idx) {
    clearTimeout(cycleTimer.current);
    clearInterval(typeTimer.current);
    if (idx === 0) { runScreen1(); scheduleNext(0); }
    else           { setCurrent(idx); scheduleNext(idx); }
  }

  return (
    <div className="ssb-banner">

      {/* ══ LEFT ══ */}
      <div className="ssb-left">
        <div className="ssb-brand">
          <img src={bankLogo} alt="Sahyadri Sahakari Bank" className="ssb-brand-logo" />
          <div>
            <p className="ssb-tagline">The Sahyadri Sahakari Bank Ltd</p>
            <p className="ssb-brand-sub">Your Trusted Banking Partner</p>
          </div>
        </div>

        <h1 className="ssb-title">Mobile Banking<br />Made Simple</h1>
        <p className="ssb-subtitle">Secure. Fast. Always with you.</p>

        <ul className="ssb-steps">
          {SLIDES.filter(s => s.step).map((s, i) => (
            <li key={s.id} className={`ssb-step${current === s.id ? " ssb-active" : ""}`}>
              <span className="ssb-step-num">{i + 1}</span>
              <span className="ssb-step-text">{s.step}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* ══ RIGHT: PHONE ══ */}
      <div className="ssb-right">
        <div className="ssb-phone">
          <div className="ssb-notch" />
          <div className="ssb-screen">

            {/* Screen 1 — Login */}
            <div className={`ssb-slide ssb-s1${current === 0 ? " ssb-slide-active" : ""}`}>
              <div className="ssb-s1-hdr">
                <div className="ssb-s1-logo">
                  <img src={bankLogo} alt="Logo" />
                </div>
                <div className="ssb-s1-bankname">The Sahyadri Sahakari<br />Bank Ltd</div>
              </div>
              <div className="ssb-s1-body">
                <div className="ssb-s1-heading">Login to your account</div>
                <div className="ssb-s1-lbl">Account Number</div>
                <div className="ssb-s1-field">
                  <span>{accTyped}</span>
                  {cursorField === "acc" && <span className="ssb-cursor" />}
                </div>
                <div className="ssb-s1-lbl">MPIN</div>
                <div className="ssb-s1-field">
                  <span>{mpinTyped}</span>
                  {cursorField === "mpin" && <span className="ssb-cursor" />}
                </div>
                <button className="ssb-s1-btn">Continue →</button>
              </div>
            </div>

            {/* Screen 2 — Dashboard */}
            <div className={`ssb-slide ssb-s2${current === 1 ? " ssb-slide-active" : ""}`}>
              <div className="ssb-s2-hdr">
                <img src={bankLogo} alt="Logo" className="ssb-s2-logo" />
                <div className="ssb-s2-verified">
                  <span className="ssb-s2-check">✓</span> Account verified
                </div>
              </div>
              <div className="ssb-s2-body">
                <div className="ssb-s2-welcome">Welcome back, Yash Dhanawde!</div>
                <div className="ssb-bal-card">
                  <div className="ssb-bal-lbl">Available Balance</div>
                  <div className="ssb-bal-amt">₹ 1,24,580.00</div>
                  <div className="ssb-bal-acno">A/C: XXXX XXXX 4821 | Savings</div>
                </div>
                <div className="ssb-txn-ttl">Recent Transactions</div>
                {TXN_S2.map(t => (
                  <div className="ssb-txn-row" key={t.name}>
                    <div>
                      <div className="ssb-txn-name">{t.name}</div>
                      <div className="ssb-txn-date">{t.date}</div>
                    </div>
                    <div className={`ssb-txn-amt ssb-${t.type}`}>{t.amt}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Screen 3 — All Transactions */}
            <div className={`ssb-slide ssb-s3${current === 2 ? " ssb-slide-active" : ""}`}>
              <div className="ssb-s3-hdr">
                <span className="ssb-s3-back">←</span>
                <div className="ssb-s3-htitle">All Transactions</div>
              </div>
              <div className="ssb-s3-body">
                <div className="ssb-chips">
                  <span className="ssb-chip ssb-chip-active">All</span>
                  <span className="ssb-chip">Credit</span>
                  <span className="ssb-chip">Debit</span>
                </div>
                {TXN_S3.map(t => (
                  <div className="ssb-txn-row" key={t.name + t.date}>
                    <div>
                      <div className="ssb-txn-name">{t.name}</div>
                      <div className="ssb-txn-date">{t.date}</div>
                    </div>
                    <div className={`ssb-txn-amt ssb-${t.type}`}>{t.amt}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Screen 4 — Disclaimer */}
            <div className={`ssb-slide ssb-s4${current === 3 ? " ssb-slide-active" : ""}`}>
              <div className="ssb-s4-inner">
                <img src={bankLogo} alt="Logo" className="ssb-s4-logo" />
                <div className="ssb-s4-icon">ℹ</div>
                <p className="ssb-s4-title">Illustration Only</p>
                <div className="ssb-s4-divider" />
                <p className="ssb-s4-note">
                  Screens shown are for illustration purposes only.
                </p>
                <p className="ssb-s4-note">
                  Actual mobile banking interface may differ.
                </p>
                <div className="ssb-s4-divider" />
                <p className="ssb-s4-brand">The Sahyadri Sahakari Bank Ltd</p>
              </div>
            </div>

          </div>
        </div>

        {/* Dots */}
        <div className="ssb-dots">
          {SLIDES.map(s => (
            <button
              key={s.id}
              className={`ssb-dot${current === s.id ? " ssb-dot-active" : ""}`}
              onClick={() => goTo(s.id)}
              aria-label={`Screen ${s.id + 1}`}
            />
          ))}
        </div>
      </div>

    </div>
  );
}